import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, TextField } from '@mui/material';
import { useTranslation } from "react-i18next";
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { eachDeep } from "deepdash-es/standalone";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import TPCheckbox from "../TemplateProperties/TPCheckbox";
import { treeActions } from '../../redux/slices/treeSlice';
import { getSelectedNodes } from '../RightContextMenu/ContextActions/CopyAndPaste';
import { cloneDeep } from 'lodash';
import Draggable from 'react-draggable';
import TreeLoading from '../Trees/TreeLoading';
import { debounce } from 'lodash';
import { getAllParentNode } from './ExpandCollapse';

const typeOptions = [
    { text: 'ALL', value: 'ALL' },
    { text: 'DIAG_SEARCH_RECORD', value: 'DIAG_SEARCH_RECORD' },
    { text: 'DIAG_SEARCH_FIELD', value: 'DIAG_SEARCH_FIELD' }
]

const compareOptions = [
    { text: 'CONTAINS', value: 'CONTAINS' },
    { text: 'EQUALS', value: 'EQUALS' },
    { text: 'STARTS_WITH', value: 'STARTS WITH' },
    { text: 'ENDS_WITH', value: 'ENDS WITH' }
]

const keyToDelete = ['alternateNodeId', 'nodeId', 'children', 'title', 'key', 'ID', 'NAME', 'SSL_TYPE','OUTBOUND_ID', 'MAX_THREADS', 'TRI_RPT_NAME', 'TRF_ID'
  , 'ENCODING', 'USE_WSDL','KEY','ID','ICON_DISPLAY', 'TRI_RPT_NAME', 'TRF_ID', 'TRF_FIELD_NAME', 'RECORD_TYPE', 'ENCODING', 'FIELDTYPE', 'IS_KEY', 'MAPNAME', 'TRIMDATA'
];

export const PaperComponent = (props) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

function SearchDialog(props) {
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector(state => state.treeData[parentScreen]);
    const templateHeader = rightTree.tree.templateHeader;
    const currentTab = rightTree.currentTab;
    const translatedData = rightTree.tree[currentTab].translatedData;
    const selectedNode = rightTree.tree[currentTab]?.selectedNode
    const { currentScreen } = useSelector(state => state.treeData)

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { open, close, setExpandActions, replace = false } = props;
    const [type, setType] = useState('');
    const [compare, setCompare] = useState('');
    const [find, setFind] = useState('');
    const [caseSensitive, setCaseSensitive] = useState();
    const [wrapSearch, setWrapSearch] = useState();
    const [direction, setDirection] = useState('');
    const [itemsFound, setItemsFound] = useState(0);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [current, setCurrent] = useState();
    const [disableNext, setDisableNext] = useState(false);
    const [showCount, setShowCount] = useState(false);
    const [radiosEnabled, setRadiosEnabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchBy, setSearchBy] = useState('NAME');
    const [replaceWith, setReplaceWith] = useState('');

    const recordTypes = ['RECORD', 'ELEMENT', 'REPEATING_ELEMENT', 'FIELD_GROUP', 'REPEATING_FIELD_GROUP', 'RECORD_TOP','RECORD_LOOP', 'JSON_TOP_RECORD', 'QUERY'];
    const fieldTypes = ['DATABASE_FIELD', 'FIELD', 'ATTRIBUTE', 'FIELD_LOOP'];
    const otherTypes = ['CONDITION_IF','CONDITION_ELSE','QUERY','COMMENT', 'VARIABLE', 'PLUGIN','ACTION_ITEM', 'VARIABLE_COLLECTION','SEQUENCE','TRACKING_REPORT_ITEM']
   
    const updateSelectedKeys = (key, temp) => {
        if (!temp?.includes(key)) {
            temp.push(key);
        }
    }

  function findInObject(obj, textToSearch, temp) {
    let keyToStore = obj?.key;
    let valid = false;

    eachDeep(obj, (value, key) => {

      if (keyToDelete.includes(key)) {
        return false; // stops going deeper for this branch
      }

      if (typeof value === 'string') {
        const fromToSearch = caseSensitive ? value : value?.toLowerCase();

        switch (compare) {
          case 'CONTAINS': {
            if (fromToSearch?.includes(textToSearch)) {
              updateSelectedKeys(keyToStore, temp);
              valid = true;
            }
            break;
          }
          case 'EQUALS': {
            if (fromToSearch?.trim() === textToSearch?.trim()) {
              updateSelectedKeys(keyToStore, temp);
              valid = true;
            }
            break;
          }
          default:
            break;
        }
      }
    })

    if (valid)
      return true;
    else
      return false;
  }

    const check = (node, fromToSearch, textToSearch, temp) => {
        let valid = false;
        switch (compare) {
            case 'CONTAINS': {
                if (fromToSearch?.includes(textToSearch)) {
                    updateSelectedKeys(node?.key, temp);
                    valid = true;
                }
                return valid;
            }
            case 'EQUALS': {
              let fromToSearchText = parentScreen !== 'workflow' ? fromToSearch.trim().split(" ")[fromToSearch.trim().split(" ").length - 1] : fromToSearch;
                if (fromToSearchText === textToSearch?.trim()) {
                    updateSelectedKeys(node?.key, temp);
                    valid = true;
                }
                return valid;
            }
            case 'STARTS WITH': {
                let fromToSearchText = parentScreen !== 'workflow' ? fromToSearch.trim().split(" ")[fromToSearch.trim().split(" ").length - 1] : fromToSearch;
                if (fromToSearchText?.startsWith(textToSearch)) {
                    updateSelectedKeys(node?.key, temp);
                    valid = true;
                }
                return valid;
            }
            case 'ENDS WITH': {
                if (fromToSearch.trim()?.endsWith(textToSearch)) {
                    updateSelectedKeys(node?.key, temp);
                    valid = true;
                }
                return valid;
            }
            default: return valid;
        }
    }
    // expand tree to higlight found matches
    const handleExpand = () => {
     const parentNodeArray = getAllParentNode(translatedData)
     setExpandActions({tab:currentTab,keys:parentNodeArray})
    }
    
    const debouncedSearchNodes = debounce(() => {
      if (find === '') {
          resetSearchState();
          return;
      }
      setLoading(true);
      setCurrent(0)
      const temp = [];
      const foundObj = {};

      if (parentScreen === 'workflow') {

        if (searchBy === 'NAME') {
          eachDeep(translatedData?.[0]?.children, (obj) => {
            const textToSearch = caseSensitive ? find : find?.toLowerCase();
            const fromToSearch = caseSensitive ? obj?.title : obj?.title?.toLowerCase()
            if (fromToSearch && check(obj, fromToSearch, textToSearch, temp)) {
              foundObj[obj.key] = true;
            }
          });
        } else {
          eachDeep(translatedData?.[0]?.children, (obj) => {
            if (['GET_DATA', 'SEND_DATA', 'TRANSLATE', 'LOOP_ITEM', 'VARIABLE_ITEM', 'CONDITION_IF', 'CONDITION_ELSE', 'CALL_PLUGIN', 'CALL_WORKFLOW', 'TRADING_PARTNER_LOOKUP', 'ACTION', 'ERROR_HANDLER', 'TRACKING_REPORT_ITEM', 'COMMENT']
              .includes(obj?.ICON_DISPLAY)) {
              const textToSearch = caseSensitive ? find : find?.toLowerCase();
              if(findInObject(obj, textToSearch, temp)){
                foundObj[obj.key] = true;
              }
            }
          });
        }
      }
      
      else
      eachDeep(translatedData[0], (obj) => {
          if (isMatchingNode(obj)) {
              const textToSearch = caseSensitive ? find : find?.toLowerCase();
              const fromToSearch = caseSensitive ? obj?.title : obj?.title?.toLowerCase()
              if (fromToSearch && check(obj, fromToSearch, textToSearch, temp)) {
                  foundObj[obj.key] = true;
              }
          }
      });
      updateSearchResults(temp, foundObj);
  }, 300);
  
  function resetSearchState() {
      setLoading(false);
      setItemsFound(0);
      setSelectedKeys([]);
      removeClass();
  }
  
  function isMatchingNode(obj) {
      if (type === t('ALL')) {
          return recordTypes?.includes(obj?.ICON_DISPLAY) || fieldTypes.includes(obj?.ICON_DISPLAY) || otherTypes.includes(obj?.ICON_DISPLAY);
      } else if (t(type) === t('DIAG_SEARCH_RECORD')) {
          return isRecordTypeMatch(obj);
      } else if (t(type) === t('DIAG_SEARCH_FIELD')) {
          return isFieldTypeMatch(obj);
      }
      return false;
  }
  
  function isRecordTypeMatch(obj) {
      return templateHeader?.FILETYPE !== 'XML' && recordTypes.includes(obj?.ICON_DISPLAY);
  }
  
  function isFieldTypeMatch(obj) {
      return templateHeader?.FILETYPE !== 'XML' && fieldTypes.includes(obj?.ICON_DISPLAY);
  }

  function updateSearchResults(temp, foundObj) {
      const foundCount = Object.keys(foundObj).length;
  
      setItemsFound(foundCount);
      if (foundCount !== 0) setDisableNext(false);
      setSelectedKeys(temp);
  
      setTimeout(() => {
          if (foundCount !== 0) {
              // highlightNodes(temp); // apply backgroundColor to searched nodes
              highlightNode(0, temp); // Ensure that the first node is selected(dispatch selectedNode to redux)
          } else {
              resetSearchState();
              setShowCount(true)
          }
      }, 0);
  }
  
  function highlightNodes(temp) {
      temp.forEach(key => {
          const element = Array.from(document.querySelectorAll(`[data-key="${key}"]`));
          element?.forEach((node) => {
              node.classList.add('highlight-search');
          })
      });
      setShowCount(false);
      setRadiosEnabled(false);
      setLoading(false);
  }
  

    const searchNodes = () => {
        setLoading(true);
        removeClass();
        handleExpand()
        debouncedSearchNodes();
    };
    useEffect(()=>{
       if(selectedKeys.length > 0){
        // handleExpand();
        highlightNodes(selectedKeys)
       } 
    },[selectedKeys])

    const removeClass = () => {
        const highligtNodes = document.querySelectorAll('.highlight-search');
        for (let i = 0; i < highligtNodes.length; i++)
            highligtNodes[i]?.classList?.remove('highlight-search');
    }

    const handleNext = () => {
        let newValue;
        if (direction === 'FORWARD') {
            if (current < selectedKeys.length - 1) newValue = current + 1;
            else newValue = 0;
            if (!wrapSearch && newValue === selectedKeys.length - 1) setDisableNext(true)
        }

        if (direction === 'BACKWARD') {
            if (current === 0) newValue = selectedKeys.length - 1;
            else newValue = current - 1;
            if (!wrapSearch && newValue === 0) setDisableNext(true)
        }

        setCurrent(newValue);
        highlightNode(newValue, selectedKeys);
    }

    const highlightNode = (newValue, temp) => {
        const key = temp[newValue];
        const node = getSelectedNodes([key], translatedData);
        const updatedTranslatedContent = cloneDeep(translatedData);
        eachDeep(translatedData, (obj) => {
            if (obj?.key === key) {
                // Dispatching Empty Node for unmounting middle panel and then mounting again
                dispatch(treeActions.setRightTreeSelectedNode({
                  screen: parentScreen,
                  type: currentTab,
                  data: {}
                }));
                setTimeout(() => {
                  dispatch(treeActions.setRightTreeSelectedNode({
                      screen: parentScreen,
                      type: currentTab,
                      data: node[0]
                  }));
                })
                dispatch(treeActions.setNewRightTreeTranslatedData({
                    screen: parentScreen,
                    type: currentTab,
                    data: updatedTranslatedContent
                }));
            }
        });
    }

    function handleReplace(replaceAll = false) {
      let replacedOnce = false;
      const textToSearch = caseSensitive ? find : find?.toLowerCase();

      const updatedData = eachDeep(
        cloneDeep(translatedData),
        (value, key, parent) => {
          if (!replaceAll && replacedOnce) return false;
          if (keyToDelete.includes(key)) return;
    
          if (typeof value !== 'string') return;
    
          const source = caseSensitive ? value : value.toLowerCase();
          const matched =
            compare === 'CONTAINS'
              ? source.includes(textToSearch)
              : source === textToSearch;
    
          if (matched) {
            parent[key] = value.split(find).join(replaceWith);
            replacedOnce = true;
          }
        },
        {
          iteratee: true // ensures arrays + objects
        }
      );

      const updatedSelectedNode = getSelectedNodes([selectedNode?.key], updatedData);
    
      if (replacedOnce) {
        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: currentTab,
            data: {}
          })
        );
    
        setTimeout(() => {
          dispatch(
            treeActions.setRightTreeSelectedNode({
              screen: parentScreen,
              type: currentTab,
              data: updatedSelectedNode[0]
            })
          );
        });
      }
    
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: currentTab,
          data: updatedData
        })
      );
    }

    useEffect(() => {
        setType('ALL');
        setCompare('CONTAINS');
        setFind('');
        setCaseSensitive(false);
        setWrapSearch(true);
        setDirection('FORWARD');
        setItemsFound(0);
        setSelectedKeys([]);
        setCurrent(0);
        setShowCount(false);
        setRadiosEnabled(false);
        setLoading(false);
        if (open) {
            removeClass();
            replace ? setSearchBy('VALUE') : setSearchBy('NAME')

        }
    }, [open]);

  useEffect(() => {
    resetSearchState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab]);

    return (
      <>
        <Dialog
          className="dialog-header"
          open={open}
          maxWidth="lg"
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title">
          <DialogTitle className="dialog-header" id="draggable-dialog-title">
            <div className="title">{replace ? t("DIAG_REPLACE_TITLE") : t("DIAG_SEARCH_TITLE")}</div>
            <div className="description">{replace ? t("DIAG_REPLACE_DESC") : t("DIAG_SEARCH_DESC")}</div>
          </DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}>
            {loading ? (
              <DialogContent className='modal-content' style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "230px"
              }} dividers>
                <CircularProgress color="primary" />
              </DialogContent>
            ) : (
              <DialogContent className="modal-content" style={{height:'230px'}} dividers>
                <Stack>
                  {parentScreen !== 'workflow' && <FormControl
                    className="width-100"
                    size="small"
                    variant="outlined">
                    <InputLabel id="typeId">{t("LBL_TYPE")}</InputLabel>
                    <Select
                      className={"width-100"}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 300,
                          },
                        },
                      }}
                      name={"TYPE"}
                      label={t("LBL_TYPE")}
                      value={type || ""}
                      onChange={(e) => {
                        setType(e.target.value);
                        setItemsFound(0);
                        setSelectedKeys([]);
                        removeClass();
                      }}>
                      {typeOptions?.map((obj, index) => (
                        <MenuItem key={obj.value + index} value={obj.value}>
                          {t(obj.text)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>}
                  {!replace && <FormControl
                    className="width-100 margin-top-12"
                    size="small"
                    variant="outlined">
                    <InputLabel id="compareId">
                      {`${t("BTN_COMPARE")}:`}
                    </InputLabel>
                    <Select
                      className={"width-100"}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 300,
                          },
                        },
                      }}
                      name={"COMPARE"}
                      label={`${t("BTN_COMPARE")}:`}
                      value={compare || ""}
                      onChange={(e) => {
                        setCompare(e.target.value);
                        setItemsFound(0);
                        setSelectedKeys([]);
                        removeClass();
                      }}>
                      {compareOptions?.map((obj, index) => (
                        <MenuItem key={obj.value + index} value={obj.value}>
                          {t(obj.text)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>}
                  <FormControl className="width-100 margin-top-12" size="small">
                    <TextField
                      variant="outlined"
                      size="small"
                      label={`${t("DIAG_SEARCH_FIND")}:`}
                      value={find || ""}
                      name="find"
                      autoComplete="off"
                      onChange={(e) => {
                        setFind(e.target.value);
                        setShowCount(false);
                        setItemsFound(0);
                        removeClass();
                      }}
                    />
                  </FormControl>
                  {replace && <FormControl className="width-100 margin-top-12" size="small">
                    <TextField
                      variant="outlined"
                      size="small"
                      label={t("FRG_REPLACE_WITH_")}
                      value={replaceWith || ""}
                      name="replaceWith"
                      autoComplete="off"
                      onChange={(e) => {
                        setReplaceWith(e.target.value);
                      }}
                      disabled={itemsFound === 0 || searchBy === 'NAME'}
                    />
                  </FormControl>}
                  <div className="flex">
                    <TPCheckbox
                      handleCheck={(checked) => {
                        setCaseSensitive(checked);
                      }}
                      label={t("DIAG_SEARCH_CASE_SENS")}
                      checked={caseSensitive}
                    />
                    <TPCheckbox
                      handleCheck={(checked) => {
                        setWrapSearch(checked);
                        if (!wrapSearch && itemsFound !== 0)
                          setDisableNext(false);
                        if (
                          wrapSearch &&
                          selectedNode?.key ===
                            selectedKeys[selectedKeys.length - 1]
                        )
                          setDisableNext(true);
                      }}
                      label={t("DIAG_SEARCH_WRAP_SEARCH")}
                      checked={wrapSearch}
                    />
                    {replace && <TPCheckbox
                      handleCheck={(checked) => {
                        setCompare(checked ? 'EQUALS' : 'CONTAINS');
                      }}
                      label={t("LBL_EXACT_MATCH")}
                      checked={compare === 'EQUALS'}
                    />}
                  </div>
                  <RadioGroup
                    row
                    name="MOVE_TYPE"
                    value={direction || "FORWARD"}
                    onChange={(e) => {
                      setDirection(e.target.value);
                      setDisableNext(false);
                    }}>
                    <FormControlLabel
                      value={"FORWARD"}
                      control={<Radio />}
                      label={t("DIAG_SEARCH_FORWARD")}
                      disabled={radiosEnabled}
                    />
                    <FormControlLabel
                      value={"BACKWARD"}
                      control={<Radio />}
                      label={t("DIAG_SEARCH_BACKWARD")}
                      disabled={radiosEnabled}
                    />
                  </RadioGroup>
                    {(currentScreen === 'outbound' || (currentScreen === 'workflow' && replace)) && (
                      <div>
                        <RadioGroup
                          row
                          name="SEARCH_BY"
                          value={searchBy || "NAME"}
                          onChange={(e) => {
                            setSearchBy(e.target.value);
                          }}>
                          <FormControlLabel
                            value={"NAME"}
                            control={<Radio />}
                            label={t("DIAG_SEARCH_BY_NAME")}
                          />
                          <FormControlLabel
                            value={"VALUE"}
                            control={<Radio />}
                            label={t("DIAG_SEARCH_BY_VALUE")}
                          />
                        </RadioGroup>
                      </div>
                    )}
                </Stack>
              </DialogContent>
            )}
          </div>
          <DialogActions>
            {itemsFound !== 0 && (
              <p>
                {t("FOUND")} ... {itemsFound}
              </p>
            )}
            {showCount && find !== "" && <p>{t("NOT_FOUND")}</p>}
            <div className="margin-left-50">
              <Button
                size="small"
                variant="outlined"
                className="margin-right-8"
                onClick={searchNodes}
                disabled={!find}>
                {t("DIAG_SEARCH_FIND")}
              </Button>
              <Button
                size="small"
                variant="outlined"
                className="margin-right-8"
                onClick={handleNext}
                disabled={itemsFound === 0 || itemsFound === 1 || disableNext}>
                {t("BTN_NEXT")}
              </Button>
              {
                replace && <>
                  <Button
                    size="small"
                    variant="outlined"
                    className="margin-right-8"
                    disabled={(itemsFound === 0) || (itemsFound > 0 && !replaceWith) || searchBy === 'NAME'}
                    onClick={() => handleReplace(false)}>
                    {t("DIAG_REPLACE")}
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    className="margin-right-8"
                    disabled={(itemsFound === 0) || (itemsFound > 0 && !replaceWith) || searchBy === 'NAME'}
                    onClick={() => handleReplace(true)}>
                    {t("DIAG_REPLACE_ALL")}
                  </Button>
                </>
              }
              <Button
                size="small"
                variant="outlined"
                className="margin-right-8"
                onClick={() => {
                  close();
                  resetSearchState();
                }}>
                {t("LBL_DONE")}
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </>
    );
}

export default SearchDialog